import { ChangeDetectionStrategy, Component, OnInit, WritableSignal, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DateTime } from 'luxon';
import { DialogService } from 'primeng/dynamicdialog';
import { finalize } from 'rxjs';
import { ExternalIncidentService } from 'src/app/api/external-incident.service';
import { FormFieldService } from 'src/app/api/form-field.service';
import { IncidentReport, REPORT_COMPLETE_STEP } from 'src/app/api/incidents.service';
import { LocalAuthService } from 'src/app/auth/local-auth.service';
import { ExternalAuthBaseComponent } from 'src/app/auth/externalAuthComponent';
import { FormProgressService } from 'src/app/storage/form-progress.service';
import { FormField } from '../../forms/formDefinition';
import { IncidentModalService } from '../../modals/incident-modal.service';
import { MessageBoxResults } from '../../modals/message-box/message-box.component';


@Component({
  selector: 'app-submit-external-report',
  templateUrl: './submit-external-report.component.html',
  styleUrls: ['./submit-external-report.component.scss'],
  providers: [DialogService],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubmitExternalReportComponent extends ExternalAuthBaseComponent implements OnInit {

  incidentReport: WritableSignal<IncidentReport | undefined> = signal(undefined);
  formFields: FormField[] = [];
  formData: any = {};

  submitError= signal("");
  showErrDetails = signal(false);
  errorCopied = signal(false);

  submittingReport = signal(false);
  submissionComplete = signal(false);

  reportComplete = signal(false);

  constructor(
    route: ActivatedRoute,
    private incidentService: ExternalIncidentService,
    private dialogService: DialogService,
    private formFieldService: FormFieldService,
    private formProgressService: FormProgressService,
    private incidentModalService: IncidentModalService,
    private router: Router,
    authService: LocalAuthService
  ) {
    super(route, authService)
  }

  override ngOnInit(): void {
    super.ngOnInit();


  }

  onExternalTokenSet(): void {

    this.route.paramMap.subscribe(params => {
      const idString = params.get("id")

      if (idString) {
        const id = Number.parseInt(idString)
        this.loadIncidentReport(id)
      }
    })
  }



  loadIncidentReport(id: number) {

    this.incidentService.getIncidentReport(id).subscribe(incidentReport => {

      this.formFieldService.getIncidentReportFields(incidentReport.incident.typeId).subscribe(
        fields => {
          this.formFields = fields

          this.formProgressService.getFormProgress(this.getFormKey(incidentReport)).subscribe(progress => {
            if (progress) {
              const progressDate = DateTime.fromJSDate(progress.lastUpdated);
              this.incidentModalService.showMessageBox(
                this.dialogService,
                "Continue Progress?",
                "You have progress from " + progressDate.toFormat("MM/dd/yyyy tt") + ". Would you like to continue where you left off?",
                { cancelButtonText: "Start Over", confirmButtonText: "Continue" }).onClose.subscribe(
                  (result: MessageBoxResults) => {
                    if (result === MessageBoxResults.Confirmed) {
                      this.formData = progress.formValue;
                    }

                    this.incidentReport.set(incidentReport);
                    if (this.incidentReport()?.incident.currentStepId === REPORT_COMPLETE_STEP) {
                      this.reportComplete.set(true);
                    }
                  }
                )
            }
            else {
              this.incidentReport.set(incidentReport);
              if (this.incidentReport()?.incident.currentStepId === REPORT_COMPLETE_STEP) {
                this.reportComplete.set(true);
              }
            }
          })

        })
    });
  }


  getFormKey(report: IncidentReport) {
    return "IncidentReportType" + report?.incident?.typeId
  }

  createReport(formData: any) {
    this.submitError.set("");
    this.showErrDetails.set( false);
    this.errorCopied.set(false);
    this.submittingReport.set( true);

    const report = this.incidentReport()

    if (report) {
      this.incidentService.submitIncidentReport({ incident: { ...report.incident, ...formData.incident }, report: { ...report.report, ...formData.report } }, report.incident.typeId).pipe(finalize(() => {
        this.submittingReport.set( false);
      })).subscribe({
        next: () => {
          this.formProgressService.clearFormProgress(this.getFormKey(report)).subscribe(() => {
            this.submissionComplete.set(true);
          })
        },
        error: (err) => {
          this.submitError.set(JSON.stringify(err, undefined, 2));
          console.error(err);
        }
      });
    }
  }

  showErrorDetails() {
    this.showErrDetails.set(true);
  }

  onErrorCopied() {
    this.errorCopied.set(true)
  }




}
